/**
 * Claude AI Reasoning Panel — button to (re)generate, plus the rendered text.
 */
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";

export default function ReasoningPanel({ reasoning, reasoningBusy, onGenerate }) {
  return (
    <div className="bg-cyan-50/50 border border-cyan-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-cyan-800 font-semibold">
          <Sparkles size={18} />
          Claude AI Reasoning
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={onGenerate}
          disabled={reasoningBusy}
          data-testid="run-reasoning"
          className="border-purple-300 text-cyan-800 hover:bg-cyan-100"
        >
          {reasoningBusy ? <Loader2 className="animate-spin mr-1" size={14} /> : <Sparkles size={14} className="mr-1" />}
          {reasoning ? "Re-generate" : "Generate"}
        </Button>
      </div>
      {reasoning ? (
        <div className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed" data-testid="reasoning-text">
          {reasoning}
        </div>
      ) : (
        <div className="text-xs text-slate-500">
          Click &quot;Generate&quot; to get a concise risk explanation from Claude Sonnet 4.5.
        </div>
      )}
    </div>
  );
}
